export default "__VITE_ASSET__DwocZdcg__"